import { render, staticRenderFns } from "./FuentesAguaPage.vue?vue&type=template&id=764d8004&"
import script from "./FuentesAguaPage.vue?vue&type=script&lang=js&"
export * from "./FuentesAguaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports